class CollectionSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('.velouria-collection-search__input');
    this.grid = document.getElementById('ProductGridContainer');
    this.countElements = [
      document.getElementById('ProductCountDesktop'),
      document.getElementById('ProductCount'),
    ].filter(Boolean);
    this.pristineCountHTML = this.countElements.map((el) => el.innerHTML);

    if (!this.input || !this.grid) return;

    this.input.addEventListener('input', this.applyFilter.bind(this));

    // Dawn's own size/color/price filters replace #ProductGridContainer's
    // content via fetch + innerHTML after every change. Re-apply whatever
    // search term is active to that fresh markup so both keep working together.
    this.gridObserver = new MutationObserver(() => {
      this.pristineCountHTML = this.countElements.map((el) => el.innerHTML);
      this.applyFilter();
    });
    this.gridObserver.observe(this.grid, { childList: true, subtree: true });
  }

  applyFilter() {
    const term = this.input.value.trim().toLowerCase();
    const items = this.grid.querySelectorAll('.grid__item[data-search-terms]');
    const emptyMessage = this.grid.querySelector('.velouria-collection-search__empty');

    if (!term) {
      items.forEach((item) => {
        item.hidden = false;
      });
      if (emptyMessage) emptyMessage.hidden = true;
      this.restoreCount();
      return;
    }

    let visibleCount = 0;
    items.forEach((item) => {
      const match = (item.dataset.searchTerms || '').includes(term);
      item.hidden = !match;
      if (match) visibleCount += 1;
    });

    if (emptyMessage) {
      if (visibleCount === 0) {
        const template = this.input.dataset.emptyLabel || '';
        emptyMessage.textContent = template.replace('__TERMS__', this.input.value.trim());
        emptyMessage.hidden = false;
      } else {
        emptyMessage.hidden = true;
      }
    }

    this.updateCount(visibleCount);
  }

  updateCount(count) {
    const template = count === 1 ? this.input.dataset.countSingular : this.input.dataset.countPlural;
    if (!template) return;
    const text = template.replace(/^\d+/, String(count));
    this.countElements.forEach((el) => {
      el.textContent = text;
    });
  }

  restoreCount() {
    this.countElements.forEach((el, index) => {
      if (this.pristineCountHTML[index] !== undefined) {
        el.innerHTML = this.pristineCountHTML[index];
      }
    });
  }
}

if (!customElements.get('collection-search')) {
  customElements.define('collection-search', CollectionSearch);
}

// Keeps the mobile drawer's "Vis X plagg" button in sync with Dawn's live
// product count (updated after every filter change) without a new counter.
(() => {
  const grid = document.getElementById('ProductGridContainer');
  const showCount = document.querySelector('.velouria-mobile-drawer__show-count');
  if (!grid || !showCount) return;

  const sync = () => {
    const source = document.getElementById('ProductCount');
    if (source && source.dataset.productCount) {
      showCount.textContent = source.dataset.productCount;
    }
  };

  new MutationObserver(sync).observe(grid, { childList: true, subtree: true });
})();

// Mirrors the compact mobile "Sorter: X" control onto Dawn's real (hidden)
// sort <select> inside #FacetFiltersFormMobile, so it submits through Dawn's
// existing, already-working sort mechanism instead of a second competing form.
document.addEventListener('change', (event) => {
  const mirrorFor = event.target.dataset ? event.target.dataset.sortMirrorFor : null;
  if (!mirrorFor) return;
  const target = document.getElementById(mirrorFor);
  if (!target) return;
  target.value = event.target.value;
  target.dispatchEvent(new Event('input', { bubbles: true }));
});
